<template>
    <div
        v-if="message || $slots.default"
        class="flex items-center gap-2 text-content-md text-content-error"
        role="alert"
    >
        <DsIcon
            icon="fa-solid fa-triangle-exclamation"
            size="sm"
        />
        <slot>{{ message }}</slot>
    </div>
</template>

<script setup lang="ts">
import DsIcon from '@ds/DsIcon.vue';

defineProps<{
    message?: string;
}>();
</script>
